export enum ActionType {
    LOAD = 'LOAD', UNLOAD = 'UNLOAD', LOAD_AND_UNLOAD = 'LOAD_AND_UNLOAD', NONE = 'NONE'
}
